
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/artist/[slug]/[collectionTaxonomy]/[collection]/artwork/[artworkSlug]",
      function () {
        return require("private-next-pages/[lang]/artist/[slug]/[collectionTaxonomy]/[collection]/artwork/[artworkSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/artist/[slug]/[collectionTaxonomy]/[collection]/artwork/[artworkSlug]"])
      });
    }
  